import { Box, styled, Typography } from '@mui/material';

export const EventBox = styled(Box)<{ selected: boolean; disabled?: boolean }>(({ selected, disabled }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '6px',
  padding: '6px 10px',
  border: '1px solid #DFDCDB',
  borderRadius: '6px',
  cursor: disabled ? 'default' : 'pointer',
  backgroundColor: selected ? '#F5F5FE' : '#FFF',
  transition: 'all 0.2s',
  opacity: disabled ? 0.6 : 1
}));

export const EventIcon = styled('img')<{ selected: boolean }>(({ selected }) => ({
  width: 20,
  height: 20,
  transition: 'filter 0.2s ease-in-out',
  filter: selected
    ? 'brightness(0) saturate(100%) invert(21%) sepia(11%) saturate(3131%) hue-rotate(219deg) brightness(96%) contrast(89%)'
    : 'brightness(0) saturate(100%) invert(76%) sepia(7%) saturate(87%) hue-rotate(336deg) brightness(85%) contrast(86%)'
}));

export const EventTitle = styled(Typography)<{ selected: boolean }>(({ selected }) => ({
  color: selected ? '#3F3273' : '',
  transition: 'color 0.2s, font-weight 0.2s'
}));
